// extracted by mini-css-extract-plugin
module.exports = {"divider":"MessageListDivider_divider__nRQN5","line":"MessageListDivider_line__39cEF","children":"MessageListDivider_children__GwVgk","isDate":"MessageListDivider_isDate__2A4xM"};